import moment from 'moment';

import { DateFormat } from '@/constants';

export default {
  data() {
    return {
      currentUrl: ''
    };
  },
  created: function() {},
  mounted: function() {
    this.currentUrl = window.location.href;
  },
  filters: {
    formatDate: function(value, formatDate) {
      if (!value) return '';
      return moment(String(value)).format(formatDate || DateFormat['HH:mm:ss DD/MM/YYYY']);
    },
    formatPrice(value) {
      if (!value) return '';
      return value.toLocaleString('da-DK');
    }
  },
  methods: {
    reloadUrl() {
      window.location.href = this.currentUrl;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/mixin.js